import { c as _c } from "react/compiler-runtime";
import { JoinNodes } from '@/globals/helpers/JoinNodes';
import { QuestionNumber, Answer, EditButton, NoAnswerInline } from '../AnsweredQuestionParts';
import { QuestionMethods } from '../questionMethods.types';
import { RenderedMultipleSelectQuestion, MultipleSelectGivenAnswer } from './multipleSelectMethods.types';
export const AnsweredQuestionMultiple: QuestionMethods<RenderedMultipleSelectQuestion, MultipleSelectGivenAnswer>['Answered'] = t0 => {
  const $ = _c(21);
  const {
    question,
    givenAnswer,
    onEdit
  } = t0;
  let T0;
  let t1;
  let t2;
  if ($[0] !== givenAnswer || $[1] !== question.answers) {
    let t3;
    if ($[5] !== givenAnswer) {
      t3 = answer => givenAnswer.has(answer.id);
      $[5] = givenAnswer;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    const answers = question.answers.filter(t3);
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <QuestionNumber />;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    T0 = Answer;
    t1 = answers.length > 0 ? <JoinNodes elements={answers.map(_temp)} separator="; " /> : <NoAnswerInline />;
    $[0] = givenAnswer;
    $[1] = question.answers;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[8] !== T0 || $[9] !== t1) {
    t3 = <T0>{t1}</T0>;
    $[8] = T0;
    $[9] = t1;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== onEdit || $[12] !== question.id) {
    t4 = () => onEdit(question.id);
    $[11] = onEdit;
    $[12] = question.id;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== question.title || $[15] !== t4) {
    t5 = <EditButton onClick={t4} questionTitle={question.title} />;
    $[14] = question.title;
    $[15] = t4;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t2 || $[18] !== t3 || $[19] !== t5) {
    t6 = <>{t2}{t3}{t5}</>;
    $[17] = t2;
    $[18] = t3;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
function _temp(answer_0) {
  return answer_0.fullTitle;
}